export default "__VITE_ASSET__zEDEGOoX__"